<template>
  <div>
    <v-card class="pa-1 ma-1">
      <v-layout>
        <v-flex class="mt-2">
          <v-text-field outlined label="Search Question" @input="()=>{if(exam){getQuestions(0)}}" v-model="searchQuery" style="height: 62px;margin-right: 5px;margin-left: 5px;"/>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs12 md6 lg4 class="pa-1">
          <v-select dense
                    label="Select Country"
                    :items="$availCountries"
                    v-model="country"
                    outlined
                    hide-details
                    @input="()=>{ examGroup = exam = paper = subg = sub = chapg = chap = topic = null; papers = subgs = subs = chapgs = chaps = topics = []; getExamGroups()}"
          />
        </v-flex>
        <v-flex xs12 md6 lg4 class="pa-1">
          <v-select dense
                    label="Select Exam Group"
                    :items="examGroups"
                    v-model="examGroup"
                    outlined
                    hide-details
                    @input="()=>{ exam = paper = subg = sub = chapg = chap = topic = null; papers = []; subg = null; subgs = []; sub = null; subs = []; chapg = null; chapgs = []; chap = null; chaps = []; topic = null; topics = []; getExams();}"
          />
          <v-progress-circular indeterminate color="blue" v-if="examGroupGetting"/>
          <v-btn text color="blue" oultine v-if="examGroupGettingError" @click="getExamGroups">Retry</v-btn>
        </v-flex>
        <v-flex xs12 md6 lg4 class="pa-1">
          <v-select dense
                    label="Select Exam"
                    :items="exams"
                    v-model="exam"
                    outlined
                    hide-details
                    @input="()=>{ paper = null; papers = []; subg = null; subgs = []; sub = null; subs = []; chapg = null; chapgs = []; chap = null; chaps = []; topic = null; topics = []; getQuestions(0); getPapers(); getSubjectGroups(); getSubjects();}"
          />
          <v-progress-circular indeterminate color="blue" v-if="examGetting"/>
          <v-btn text color="blue" oultine v-if="examGettingError" @click="getExams">Retry</v-btn>
        </v-flex>
        <v-flex xs12 md6 lg4 class="pa-1" >
          <v-select dense
                    label="Select Subject Group"
                    :items="subgs"
                    outlined
                    hide-details
                    v-model="subg"
                    @input="()=>{ sub = null; subs = []; chapg = null; chapgs = []; chap = null; chaps = []; topic = null; topics = []; getQuestions(0); getSubjects(); }"
          />
          <v-progress-circular indeterminate color="blue" v-if="subgGetting"/>
          <v-btn text color="blue" oultine v-if="subgGettingError" @click="getSubjectGroups">Retry</v-btn>
        </v-flex>
        <v-flex xs12 md6 lg4 class="pa-1" >
          <v-select dense
                    label="Select Subject"
                    :items="subs"
                    v-model="sub"
                    @input="()=>{ chapg = null; chapgs = []; chap = null; chaps = []; topic = null; topics = []; getQuestions(0); getChapterGroups(); getChapters();}"
                    outlined
                    hide-details
          />
          <v-progress-circular indeterminate color="blue" v-if="subGetting"/>
          <v-btn text color="blue" oultine v-if="subGettingError" @click="getSubjects">Retry</v-btn>
        </v-flex>
        <v-flex xs12 md6 lg4 class="pa-1" >
          <v-select dense
                    label="Select Chapter Group"
                    :items="chapgs"
                    v-model="chapg"
                    @input="()=>{ chap = null; chaps = []; topic = null; topics = []; getQuestions(0); getChapters();}"
                    outlined
                    hide-details
          />
          <v-progress-circular indeterminate color="blue" v-if="chapgGetting"/>
          <v-btn text color="blue" oultine v-if="chapgGettingError" @click="getChapterGroups">Retry</v-btn>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs12 md6 lg4 class="pa-1">
          <v-select dense
                    label="Select Chapter"
                    :items="chaps"
                    v-model="chap"
                    @input="(val)=>{ topic = null; topics = chaps.filter(el=> el.value === val)[0].topics; getQuestions(0);  }"
                    outlined
                    hide-details
          />
          <v-progress-circular indeterminate color="blue" v-if="chapGetting"/>
          <v-btn text color="blue" oultine v-if="chapGettingError" @click="getChapters">Retry</v-btn>
        </v-flex>
        <v-flex xs12 md6 lg4 class="pa-1">
          <v-select dense
                    label="Select Topic"
                    :items="topics"
                    v-model="topic"
                    @input="()=>{ getQuestions(0);}"
                    outlined
                    hide-details
          />
        </v-flex>
        <v-flex xs12 md6 lg4 class="pa-1">
          <v-select dense
                    label="Select Paper"
                    :items="papers"
                    v-model="paper"
                    @input="()=>{ getQuestions(0);}"
                    outlined
                    hide-details
          />
          <v-progress-circular indeterminate color="blue" v-if="paperGetting"/>
          <v-btn text color="blue" oultine v-if="paperGettingError" @click="getPapers">Retry</v-btn>
        </v-flex>
      </v-layout>
    </v-card>
    <v-layout wrap style="margin-top: 5px">
      <v-flex xs12 md6 lg4 class="pa-1" :key="q.question_id" v-for="q in questions">
        <v-card
            :color="getColor(q)"
            dark
        >
          <div class="pa-2">
            <b>Paper:</b>
            {{q.paperTitle}}
          </div>
          <v-divider/>
          <div
              class="pa-1"
              style="word-wrap: break-word; height: 85px"
          >{{q.question[q.languages[0]].content.substring(0, 100).concat(q.question[q.languages[0]].content.length > 100 ? '...' : '')}}</div>
          <v-divider/>
          <div class="pa-2">
            <b>Languages:</b>
            {{q.languages.map(el=>{return $getLangName(el)}).toString()}}
          </div>
          <v-divider/>
          <v-card-actions>
            <b>Marks:&nbsp;</b>
            {{q.marks}}/{{q.negMarks}}
            &nbsp;
            <b>Difficulty:&nbsp;</b>
            {{q.difficulty ? q.difficulty.toUpperCase() : "None"}}
            <v-spacer/>
            <v-btn
                text
                small
                outlined
                @click="$router.push('/pastquestions'.concat('/update/').concat(q.question_id))"
            >Update</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <div class="pa-4 text-center">
      <div v-if="!questionGetting && questionGettingError">
        <h2 class="pa-4 title">Unknown Error Found</h2>
        <v-btn outlined @click="()=>{getQuestions()}">Retry</v-btn>
      </div>
      <div v-else-if="!exam">
        <h2 class="pa-4 title">Select Exam to View Questions</h2>
      </div>
      <div v-else-if="!questionGetting && exam && noMoreQuestions">
        <h2 class="pa-4 title">No {{questions.length > 0 ? "More" : ""}} Questions Found</h2>
      </div>
      <div
          v-else-if="!questionGetting && !questionGettingError && exam && noMoreQuestions === false"
      >
        <v-btn color="red" outlined text @click="()=>{getQuestions()}">Load More</v-btn>
      </div>
      <v-progress-circular color="red" v-if="questionGetting" indeterminate/>
    </div>
  </div>
</template>

<script>
export default {
  name: "all",
  props: {
    abs: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    async getExamGroups() {
      this.examGroupGetting = true;
      this.examGroupGettingError = false;
      try {
        const { data } = await this.$http2.get("/examGroup", {
          params: {
            country: this.country,
          },
        });
        if (data.statusCode === 0) {
          this.examGroups = data.results.map((el) => {
            return { value: el.key, text: el.title['en'] };
          });
        } else {
          this.examGroupGettingError = true;
          this.$message.error(data.error.message);
        }
      } catch (error) {
        this.examGroupGettingError = true;
        this.$message.error(error.message);
      }
      this.examGroupGetting = false;
    },
    getExams() {
      this.examGetting = true;
      this.examGettingError = false;
      this.$http2
        .get("/exam", {
          params: { country: this.country, examGroup: this.examGroup },
        })
        .then((res) => {
          this.examGetting = false;
          let json = res.data;
          if (json.statusCode === 0) {
            this.exams = json.results.map((el) => {
              return { value: el.key, text: el.title['en'] };
            });
          } else {
            this.examGettingError = true;
          }
        })
        .catch((err) => {
          this.examGetting = false;
          this.examGettingError = true;
        });
    },
    getSubjectGroups() {
      this.subgGetting = true;
      this.subgGettingError = false;
      this.$http2
        .get("/subjectGroup", {
          params: {
            country: this.country,
            examGroup: this.examGroup,
            exam: this.exam,
          },
        })
        .then((res) => {
          this.subgGetting = false;
          let json = res.data;
          if (json.statusCode === 0) {
            this.subgs = json.results.map((el) => {
              return { value: el.key, text: el.title['en'] };
            });
          } else {
            this.subgGettingError = true;
          }
        })
        .catch((err) => {
          this.subgGetting = false;
          this.subgGettingError = true;
        });
    },
    getSubjects() {
      this.subGetting = true;
      this.subGettingError = false;
      const post = {
        country: this.country,
        examGroup: this.examGroup,
        exam: this.exam,
      };
      if (this.subg) {
        post["subjectGroup"] = this.subg;
      }
      this.$http2
        .get("/subject", { params: post })
        .then((res) => {
          this.subGetting = false;
          let json = res.data;
          if (json.statusCode === 0) {
            this.subs = json.results.map((el) => {
              return { value: el.key, text: el.title['en'] };
            });
          } else {
            this.subGettingError = true;
          }
        })
        .catch((err) => {
          this.subGetting = false;
          this.subGettingError = true;
        });
    },
    getChapterGroups() {
      this.chapgGetting = true;
      this.chapgGettingError = false;
      let post = {
        country: this.country,
        examGroup: this.examGroup,
        exam: this.exam,
        subject: this.sub,
      };
      if (this.subg) {
        post["subjectGroup"] = this.subg;
      }
      this.$http2
        .get("/chapterGroup", { params: post })
        .then((res) => {
          this.chapgGetting = false;
          let json = res.data;
          if (json.statusCode === 0) {
            this.chapgs = json.results.map((el) => {
              return { value: el.key, text: el.title['en'] };
            });
          } else {
            this.chapgGettingError = true;
          }
        })
        .catch((err) => {
          this.chapgGetting = false;
          this.chapgGettingError = true;
        });
    },
    getChapters() {
      this.chapGetting = true;
      this.chapGettingError = false;
      const posb = {
        country: this.country,
        examGroup: this.examGroup,
        exam: this.exam,
        subject: this.sub,
      };
      if (this.subg) {
        posb["subjectGroup"] = this.subg;
      }
      if (this.chapg) {
        posb["chapterGroup"] = this.chapg;
      }
      this.$http2
        .get("/chapter", { params: posb })
        .then((res) => {
          this.chapGetting = false;
          let json = res.data;
          if (json.statusCode === 0) {
            this.chaps = json.results.map((el) => {
              return { value: el.key, text: el.title['en'], topics: el.topics || [] };
            });
          } else {
            this.chapGettingError = true;
          }
        })
        .catch((err) => {
          this.chapGetting = false;
          this.chapGettingError = true;
        });
    },
    getPapers() {
      this.paperGetting = true;
      this.paperGettingError = false;
      const pob = {
        country: this.country,
        examGroup: this.examGroup,
        exam: this.exam,
      };
      this.$http2
        .get("/paper", { params: pob })
        .then((res) => {
          this.paperGetting = false;
          let json = res.data;
          if (json.statusCode === 0) {
            this.papers = json.results.map((el) => {
              return { value: el.key, text: el.title['en'] };
            });
          } else {
            this.paperGettingError = true;
          }
        })
        .catch((err) => {
          this.paperGetting = false;
          this.paperGettingError = true;
        });
    },
    getQuestions(page) {
      if (typeof page !== "undefined") {
        this.nextPage = Number(page);
      }
      if (this.nextPage === 0) {
        this.questions = [];
        this.noMoreQuestions = false;
      }
      this.questionGetting = true;
      this.questionGettingError = false;
      this.$http
        .get("/question/past/list", {
          params: {
            country: this.country,
            examGroup: this.examGroup,
            exam: this.exam,
            subjectGroup: this.subg,
            subject: this.sub,
            chapterGroup: this.chapg,
            chapter: this.chap,
            topic: this.topic,
            paper: this.paper,
            page: this.nextPage,
            q: this.searchQuery,
          },
        })
        .then((res) => {
          this.questionGetting = false;
          let json = res.data;
          if (json.statusCode === 0) {
            json.data.forEach((l) => this.questions.push(l));
            if (json.data.length === 0) {
              this.noMoreQuestions = true;
              this.$message.warning(
                `No ${this.questions.length > 0 ? "More" : ""} Questions Found`
              );
            } else if (json.data.length < 10) {
              this.noMoreQuestions = true;
            } else {
              this.nextPage++;
            }
          } else {
            this.questionGettingError = true;
          }
        })
        .catch((err) => {
          console.log(err);
          this.questionGetting = false;
          this.questionGettingError = true;
        });
    },
    getColor(q) {
      if (!q.status) return "red";
      if (q.status === "public") {
        if (q.question["en"].explanation === null) {
          return "purple";
        } else {
          return "green";
        }
      } else {
        if (q.question["en"].explanation != null) {
          return "teal";
        } else {
          if (q.status === "review") return "blue darken-2";
          return "pink";
        }
      }
    },
  },
  data() {
    return {
      searchQuery: null,

      megUpdate: false,

      questions: [],
      nextPage: 0,
      questionGetting: false,
      questionGettingError: false,

      topics: [],
      topic: null,
      noMoreQuestions: false,
      //State of Networking
      examGroupGetting: false,
      examGetting: false,
      examGroupGettingError: false,
      examGettingError: false,
      subgGetting: false,
      subgGettingError: false,
      subGetting: false,
      subGettingError: false,
      chapgGetting: false,
      chapgGettingError: false,
      chapGetting: false,
      chapGettingError: false,
      topicGetting: false,
      topicGettingError: false,
      paperGetting: false,
      paperGettingError: false,

      examGroups: [],
      exams: [],
      papers: [],
      paper: null,
      examGroup: null,
      country: null,
      exam: null,
      subgs: [],
      subg: null,
      subs: [],
      sub: null,
      chapgs: [],
      chapg: null,
      chaps: [],
      chap: null,
    };
  },
};
</script>

<style scoped>
</style>
